import React from 'react'
import PropTypes from 'prop-types'
import NumberFormat from 'react-number-format'
import { Link } from 'react-router'
import moment from 'moment'

import InvitedCreators from '../../InvitedCreators'

import Styles from './index.scss'

const TabProjectDetails = props => (
  <section className={'section-tab'}>
    <div className={`content ${Styles['border-content']} ${Styles['project-detail']}`}>
      <h3 className={`${Styles.title}`}>Project Details</h3>
      <div className={`${Styles['item-container']}`}>
        <div className={`${Styles['item-rows']}`}>
          <span className={`${Styles['item-label']}`}>Product Type</span>
          <span className={`${Styles['item-value']}`}>
            {props.order.productType.name}
          </span>
        </div>
        <div className={`${Styles['item-rows']} ${Styles.service}`}>
          <span className={`${Styles['item-label']}`}>Service</span>
          <span className={`${Styles['item-value']}`}>{props.order.service.name}</span>
        </div>
        <div className={`${Styles['item-rows']}`}>
          <span className={`${Styles['item-label']}`}>Objective</span>
          <span className={`${Styles['item-value']}`}>{props.order.objective}</span>
        </div>
        <div className={`${Styles['item-rows']}`}>
          <span className={`${Styles['item-label']}`}>Status</span>
          <span className={`${Styles['item-value']}`}>{props.order.statusLabel}</span>
        </div>
        <div className={`${Styles['item-rows']}`}>
          <span className={`${Styles['item-label']}`}>Currency</span>
          <span className={`${Styles['item-value']}`}>{props.order.currency}</span>
        </div>
        <div className={`${Styles['item-rows']}`}>
          <span className={`${Styles['item-label']}`}>Budget</span>
          <span className={`${Styles['item-value']}`}>
            <NumberFormat
              thousandSeparator
              displayType="text"
              value={props.order.budget}
            />
          </span>
        </div>
        <div className={`${Styles['item-rows']}`}>
          <span className={`${Styles['item-label']}`}>CPV</span>
          <span className={`${Styles['item-value']}`}>
            <NumberFormat thousandSeparator displayType="text" value={props.order.cpv} />
          </span>
        </div>
        <div className={`${Styles['item-rows']}`}>
          <span className={`${Styles['item-label']}`}>Viewer</span>
          <span className={`${Styles['item-value']}`}>
            <NumberFormat
              thousandSeparator
              displayType="text"
              value={props.order.viewers}
            />
          </span>
        </div>
        <div className={`${Styles['item-rows']}`}>
          <span className={`${Styles['item-label']}`}>Date Created</span>
          <span className={`${Styles['item-value']}`}>
            {moment(props.order.createdAt).format('DD MMMM YYYY')}
          </span>
        </div>
        <div className={`${Styles['item-rows']}`}>
          <span className={`${Styles['item-label']}`}>Last Updated</span>
          <span className={`${Styles['item-value']}`}>
            {moment(props.order.updatedAt).format('DD MMMM YYYY')}
          </span>
        </div>
        <div className={`${Styles['item-rows']}`}>
          <span className={`${Styles['item-label']}`}>Price AVG</span>
          <span className={`${Styles['item-value']}`}>
            <NumberFormat
              thousandSeparator
              displayType="text"
              value={parseInt(props.order.price_avg, 10)}
            />
          </span>
        </div>
        <div className={`${Styles['item-rows']}`}>
          <span className={`${Styles['item-label']}`}>Creative Idea</span>
          <span className={`${Styles['item-value']}`}>
            <div
              dangerouslySetInnerHTML={{
                __html: props.order.creativeIdea.replace(/^<(p.*?)>/gi, ''),
              }}
            />
          </span>
        </div>
        <div className={`${Styles['item-rows']}`}>
          <span className={`${Styles['item-label']}`}>End Date</span>
          <span className={`${Styles['item-value']}`}>
            {moment(props.order.endDate).format('DD MMMM YYYY')}
          </span>
        </div>
        <div className={`${Styles['item-rows']}`}>
          <span className={`${Styles['item-label']}`}>Profile ID</span>
          <span className={`${Styles['item-value']}`}>{props.order.profileId}</span>
        </div>
        <div className={`${Styles['item-rows']}`}>
          <span className={`${Styles['item-label']}`}>Start Date</span>
          <span className={`${Styles['item-value']}`}>
            {moment(props.order.startDate).format('DD MMMM YYYY')}
          </span>
        </div>
        <div className={`${Styles['item-rows']}`}>
          <span className={`${Styles['item-label']}`}>Target Audience</span>
          <span className={`${Styles['item-value']}`}>
            <div
              dangerouslySetInnerHTML={{
                __html: props.order.targetAudience.replace(/^<(p.*?)>/gi, ''),
              }}
            />
          </span>
        </div>
        <div className={`${Styles['item-rows']}`}>
          <span className={`${Styles['item-label']}`}>Total Audience</span>
          <span className={`${Styles['item-value']}`}>Value</span>
        </div>
        <div className={`${Styles['item-rows']}`}>
          <span className={`${Styles['item-label']}`}>Total Content</span>
          <span className={`${Styles['item-value']}`}>{props.order.totalContent}</span>
        </div>
        <div className={`${Styles['item-rows']}`}>
          <span className={`${Styles['item-label']}`}>Organic Y/N</span>
          <span className={`${Styles['item-value']}`}>
            {props.order.isOrganic ? 'Yes' : 'No'}
          </span>
        </div>
        <div className={`${Styles['item-rows']}`}>
          <span className={`${Styles['item-label']}`}>Managed</span>
          <span className={`${Styles['item-value']}`}>
            {props.order.manager ? 'Yes' : 'No'}
          </span>
        </div>
        {props.order.manager && (
          <div className={`${Styles['item-rows']}`}>
            <span className={`${Styles['item-label']}`}>Manage Percentage</span>
            <span
              className={`${Styles['item-value']}`}
            >{`${props.order.managePrctgFee}%`}</span>
          </div>
        )}
      </div>
    </div>
    <div className={`content ${Styles['right-content']}`}>
      <div className={`${Styles['border-content']} ${Styles['comment-content']}`}>
        <div className="blog-comments">
          <h3 className="sbold blog-comments-title">{`Comments(${props.comments.count})`}</h3>
          <h4 className="sbold blog-comments-title">{`Unique Commenters(${
            props.comments.rows.filter(
              (comment, index, self) =>
                self.findIndex(c => c.user.id === comment.user.id) === index
            ).length
          })`}</h4>
          <div className="c-comment-list">
            {props.comments.rows.map(comment => (
              <div key={comment.id} className="media">
                <div className="media-left">
                  <Link to={`/profiles/${comment.profile.profileId}`}>
                    <img
                      style={{ width: '50px' }}
                      className="media-object"
                      alt=""
                      src={comment.profile.logo}
                    />
                  </Link>
                </div>
                <div className="media-body">
                  <h4 className="media-heading">
                    <Link to={`/profiles/${comment.profile.profileId}`}>
                      {`${comment.user.firstName} - ${comment.profile.name}`}
                    </Link>
                    <br />
                    {'on '}
                    <span className="c-date">
                      {moment(comment.createdAt).format('DD MMMM YYYY h:mm:ss a')}
                    </span>
                    {comment.isDeleted ? (
                      <span style={{ float: 'right', fontSize: '20px', color: 'red' }}>
                        Deleted
                      </span>
                    ) : (
                      <Link
                        style={{ float: 'right', fontSize: '30px', color: 'red' }}
                        onClick={props.handleDeleteComment(
                          comment.id,
                          props.order.id,
                          props.comments.rows.length
                        )}
                      >
                        <i className="fa fa-trash" />
                      </Link>
                    )}
                  </h4>
                  <div dangerouslySetInnerHTML={{ __html: comment.say }} />
                </div>
              </div>
            ))}
          </div>
          <h3 className="sbold blog-comments-title">Post a Comment</h3>
          <form onSubmit={props.handleSubmitComment}>
            <div className="form-group">
              <textarea
                style={{ resize: 'none' }}
                rows="5"
                name="message"
                placeholder="Write comment here ..."
                className="form-control c-square"
                onChange={props.handleWriteComment}
              />
            </div>
            <div className="form-group">
              <button type="submit" className="btn blue uppercase btn-md sbold btn-block">
                Submit
              </button>
            </div>
          </form>
          {props.comments.count !== props.comments.rows.length && (
            <Link
              onClick={props.handleLoadMore(props.comments.rows.length, props.order.id)}
            >
              Load More
            </Link>
          )}
        </div>
      </div>
      <div className={`${Styles['border-content']} ${Styles['comment-content']}`}>
        <InvitedCreators />
      </div>
    </div>
  </section>
)

TabProjectDetails.propTypes = {
  comments: PropTypes.shape({
    rows: PropTypes.arrayOf(PropTypes.object).isRequired,
    count: PropTypes.number.isRequired,
    totalPages: PropTypes.number.isRequired,
    currentPage: PropTypes.number.isRequired,
  }).isRequired,
  handleSubmitComment: PropTypes.func.isRequired,
  handleWriteComment: PropTypes.func.isRequired,
  handleLoadMore: PropTypes.func.isRequired,
  order: PropTypes.shape({
    id: PropTypes.string.isRequired,
    country: PropTypes.shape({
      name: PropTypes.string,
    }).isRequired,
    service: PropTypes.shape({
      name: PropTypes.string,
    }).isRequired,
    objective: PropTypes.string.isRequired,
    statusLabel: PropTypes.string.isRequired,
    currency: PropTypes.string.isRequired,
    cpv: PropTypes.number.isRequired,
    budget: PropTypes.number.isRequired,
    viewers: PropTypes.number.isRequired,
    createdAt: PropTypes.string.isRequired,
    updatedAt: PropTypes.string.isRequired,
    price_avg: PropTypes.string.isRequired,
    creativeIdea: PropTypes.string.isRequired,
    endDate: PropTypes.string.isRequired,
    profileId: PropTypes.string.isRequired,
    startDate: PropTypes.string.isRequired,
    targetAudience: PropTypes.string.isRequired,
    totalContent: PropTypes.number.isRequired,
    isOrganic: PropTypes.bool.isRequired,
    productType: {
      name: PropTypes.string.isRequired,
    },
    isManaged: PropTypes.bool.isRequired,
    manager: PropTypes.object,
    managePrctgFee: PropTypes.number.isRequired,
    orderManagers: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
}

export default TabProjectDetails
